import * as DownloadDocumentTypes from 'src/actions/project/download-document/Types';
import { DownloadDocumentAction } from 'src/actions/project/download-document/DownloadDocument.actions';

export interface DownloadDocumentState {
  loading: boolean;
  error: boolean;
}

const initialState: DownloadDocumentState = {
  loading: false,
  error: false,
};

export function DownloadDocumentReducer(state: DownloadDocumentState = initialState,
                                        action: DownloadDocumentAction): DownloadDocumentState {
  switch (action.type) {
    case DownloadDocumentTypes.DOWNLOAD_DOCUMENT_ATTEMPT:
      return { ...state, loading: true, error: false };
    case DownloadDocumentTypes.DOWNLOAD_DOCUMENT_SUCCESS:
      return { ...state,  loading: false, error: false };
    case DownloadDocumentTypes.DOWNLOAD_DOCUMENT_FAILURE:
      return {...state, loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/DownloadDocument.reducer.tsx